import React from 'react';
import Navbar from '../../components/Navbar'
// import PageTitle from '../../components/pagetitle'
import Contactpage from '../../components/Contactpage'
import Footer from '../../components/footer'
import Scrollbar from '../../components/scrollbar'
import Logo from '../../images/logo.png'

const ContactPage =() => {
    return(
        <div className="wpo-contact-page-layout">
            <Navbar Logo={Logo}/>
            {/* <PageTitle pageTitle={'Contact Us'} pagesub={'Contact'}/>  */}
            <Contactpage/>
            <Footer/>
            <Scrollbar/>
        </div>
    )
};
export default ContactPage;
